import { FilterIcon } from '../../../../../../assets/svg/filter';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import s from './dashboard-filters.module.css';
import { useDashboardFilters } from './use-dashboard-filters';

export const DashboardFilters = () => {
  const { branches, qrs, t } = useDashboardFilters();

  return (
    <DropdownFilter
      label={t('Фильтр')}
      className={s.feature}
      leftIcon={<FilterIcon />}
      options={[
        {
          label: t('По дате'),
          value: 'range',
          filter: 'datetime-range',
        },
        {
          label: t('По филиалам'),
          value: 'branch',
          filter: 'single-select',
          filterOptions: branches,
        },
        {
          label: t('По QR-кодам'),
          value: 'qr',
          filter: 'multi-select',
          filterOptions: qrs,
        },
      ]}
    />
  );
};
